import { ComponentEx } from "./ComponentEx";
import { HOVER_DELAY } from "./constants";
import Dropdown from "./Dropdown";
import Icon from "./Icon";
import * as React from "react";
import { MenuItem } from "react-bootstrap";
import ReactDOM from "react-dom";
import { Portal } from "react-overlays";
import { clearTimeout } from "timers";
function MenuAction(props) {
    const { t, action, id, instanceId, onTrigger } = props;
    const renderCustom = React.useCallback(() => {
        const knownProps = [
            "condition",
            "className",
            "group",
            "t",
            "i18nLoadedAt",
            "objects",
            "children",
        ];
        const unknownProps = Object.keys(props).reduce((prev, current) => {
            if (knownProps.indexOf(current) === -1) {
                return {
                    ...prev,
                    [current]: props[current],
                };
            }
            else {
                return prev;
            }
        }, {});
        const staticProps = {
            ...unknownProps,
            key: id,
        };
        if (action.props !== undefined) {
            const addProps = action.props();
            return (React.createElement(action.component, { ...staticProps, ...addProps, parentType: "context" }));
        }
        else {
            return React.createElement(action.component, { ...staticProps, parentType: "context" });
        }
    }, [props]);
    // stuff for submenus
    const [open, setOpenMenu] = React.useState(false);
    const [subMenus, setSubMenus] = React.useState([]);
    const setOpen = React.useCallback((value) => {
        if (subMenus.length === 0) {
            if (Array.isArray(action.subMenus)) {
                setSubMenus(action.subMenus);
            }
            else {
                setSubMenus(action.subMenus());
            }
        }
        setOpenMenu(value);
    }, [setOpenMenu, action.subMenus]);
    const setOpenFalse = React.useCallback(() => {
        setOpen(false);
    }, [setOpen]);
    const itemRef = React.useRef();
    const trigger = React.useCallback(() => {
        if (hideTimer.current) {
            clearTimeout(hideTimer.current);
        }
        const instanceIds = typeof instanceId === "string" ? [instanceId] : instanceId;
        action.action?.(instanceIds, action.data);
        if (action.subMenus !== undefined) {
            setOpen((old) => !old);
        }
        else {
            onTrigger?.();
        }
    }, [instanceId, action, setOpen]);
    const hideTimer = React.useRef();
    const show = React.useCallback(() => {
        if (hideTimer.current) {
            clearTimeout(hideTimer.current);
        }
        hideTimer.current = setTimeout(() => {
            setOpen(true);
        }, HOVER_DELAY);
    }, [setOpen, hideTimer.current]);
    const hide = React.useCallback(() => {
        if (hideTimer.current) {
            clearTimeout(hideTimer.current);
        }
        hideTimer.current = setTimeout(() => {
            setOpen(false);
        }, HOVER_DELAY);
    }, [setOpen]);
    const setItemRef = (ref) => {
        itemRef.current = ReactDOM.findDOMNode(ref);
    };
    return (React.createElement(MenuItem, { eventKey: id, onSelect: trigger, onMouseEnter: action.subMenus !== undefined ? show : undefined, onMouseLeave: action.subMenus !== undefined ? hide : undefined, disabled: action.show !== true, ref: setItemRef, title: typeof action.show === "string" ? t(action.show) : undefined },
        action.component !== undefined ? (renderCustom()) : (React.createElement(React.Fragment, null,
            action.icon !== undefined ? React.createElement(Icon, { name: action.icon }) : null,
            React.createElement("div", { className: "button-text" }, t(action.title)))),
        action.subMenus !== undefined ? (React.createElement(React.Fragment, null,
            React.createElement(ContextMenu, { instanceId: instanceId, visible: open, anchor: itemRef.current, onHide: setOpenFalse, actions: subMenus, onTrigger: onTrigger }),
            React.createElement(Icon, { className: "menu-more-icon", name: "showhide-right" }))) : null));
}
class RootCloseWrapper extends React.Component {
    componentDidMount() {
        document.addEventListener("click", this.close);
        document.addEventListener("contextmenu", this.close);
    }
    componentWillUnmount() {
        document.removeEventListener("click", this.close);
        document.removeEventListener("contextmenu", this.close);
    }
    render() {
        return this.props.children;
    }
    close = (evt) => {
        if (!evt.defaultPrevented) {
            this.props.onClose();
        }
    };
}
function nop() {
    // nop
}
class ContextMenu extends ComponentEx {
    mMenuRef = null;
    constructor(props) {
        super(props);
        this.initState({
            right: 0,
            bottom: 0,
        });
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.visible !== newProps.visible && newProps.visible) {
            this.updatePlacement(newProps.position);
        }
    }
    render() {
        const { actions, children, className, onHide, position, visible } = this.props;
        const { right, bottom } = this.state;
        if (!visible || (actions || []).length === 0) {
            return null;
        }
        const menuStyle = { position: "absolute" };
        if (right !== undefined) {
            menuStyle["right"] = right;
        }
        else {
            menuStyle["left"] = position.x;
        }
        if (bottom !== undefined) {
            menuStyle["bottom"] = bottom;
        }
        else {
            menuStyle["top"] = position.y;
        }
        return (React.createElement(RootCloseWrapper, { onClose: onHide },
            React.createElement(Portal, { container: this.context.menuLayer },
                React.createElement("div", { className: className, style: menuStyle, ref: this.setMenuRef },
                    React.createElement("div", { className: "menu-content" }, children),
                    React.createElement(Dropdown.Menu, { style: { display: "block", position: "initial" }, open: true, onClose: onHide, onClick: nop }, (actions || []).map(this.renderMenuItem))))));
    }
    renderMenuItem = (action, index) => {
        const { t, instanceId } = this.props;
        const id = `${instanceId || "1"}_${index}`;
        const tf = t ?? ((input) => input);
        if (action.icon === null &&
            action.component === undefined &&
            action.action === undefined) {
            return (React.createElement(MenuItem, { className: "menu-separator-line", key: id, disabled: true }, action.title !== undefined ? tf(action.title) : React.createElement("hr", null)));
        }
        return (React.createElement(MenuAction, { t: tf, key: id, id: id, onTrigger: this.trigger, action: action, instanceId: instanceId }));
    };
    trigger = () => {
        const { onHide, onTrigger } = this.props;
        onTrigger?.();
        onHide();
    };
    setMenuRef = (ref) => {
        this.mMenuRef = ref;
        if (ref !== null) {
            this.updatePlacement(this.props.position);
        }
    };
    updatePlacement(position) {
        if (this.mMenuRef === null) {
            return;
        }
        const rect = this.mMenuRef.getBoundingClientRect();
        const outer = this.context.menuLayer.getBoundingClientRect();
        if (position !== undefined) {
            this.nextState.bottom =
                position.y + rect.height > outer.bottom
                    ? outer.bottom - position.y
                    : undefined;
            this.nextState.right =
                position.x + rect.width > outer.right
                    ? outer.right - position.x
                    : undefined;
        }
        else if (!!this.props.anchor) {
            const bbrect = this.props.anchor.getBoundingClientRect();
            this.nextState.bottom = Math.max(0, outer.bottom - bbrect.y - rect.height);
            let right = outer.right - bbrect.right - rect.width;
            if (right < 0) {
                right = outer.right - bbrect.left;
            }
            this.nextState.right = right;
        }
        else {
            this.nextState.bottom = 0;
            this.nextState.right = 0;
        }
    }
}
export default ContextMenu;
